module.exports = __webpack_public_path__ + "img/38.0739b9a4.jpg";